<script setup lang="ts">
import DatePicker from '@vuepic/vue-datepicker'

const modelValue = defineModel<{ year: number; month: number } | null>()
</script>

<template>
  <DatePicker
    v-model="modelValue"
    id="opportunity-deadline"
    locale="fr"
    month-picker
    auto-apply
    format="MM/yyyy"
  >
  </DatePicker>
</template>
